export const SideCollapse = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9112_2574"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="34"
        height="34"
      >
        <rect width="34" height="34" rx="17" fill="white" />
      </mask>
      <g mask="url(#mask0_9112_2574)">
        <rect
          x="0.5"
          y="0.5"
          width="33"
          height="33"
          rx="16.5"
          fill="var(--white-marble)"
          stroke="var(--neutral-300)"
        />
        <rect
          x="-2.03906"
          y="32.6399"
          width="4.76"
          height="4.76"
          rx="2.38"
          fill="var(--white-marble)"
        />
      </g>
      <g clipPath="url(#clip0_9112_2574)">
        <path
          d="M21.5 11H12.5C11.6716 11 11 11.6716 11 12.5V21.5C11 22.3284 11.6716 23 12.5 23H21.5C22.3284 23 23 22.3284 23 21.5V12.5C23 11.6716 22.3284 11 21.5 11Z"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 11V23"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.25 15.5L17.75 17L19.25 18.5"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9112_2574">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideCollapse;
